import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-audio-player]';
export const PLUGIN_NAME = 'audioPlayer';

$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
	const element = this;
	System.import(/* webpackChunkName: "component--audio-player" */ './audio-player').then(() => {
        $(element)[PLUGIN_NAME]();
    });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/audio-player/index.js